import api from "@/lib/api";

const urlBase = "/api/v1/financial/authorization";

export default {
    urlGetAll: `${urlBase}/get-all`,
    urlChangeStatus: `${urlBase}/change-status`,

    async list(filter = {}) {
        const response = await api.get(this.urlGetAll, { params: filter });
        return response.data;
    },
};
